import { Badge } from '@/new/components/shadcn/badge';
import { SubTitle } from '@/new/components/subtitle';

export function SettingsHeader({
  title,
  subheading,
  action,
  hasUnsavedChanges = false,
}: {
  title: string;
  subheading: React.ReactNode;
  action?: React.ReactNode;
  hasUnsavedChanges?: boolean;
}) {
  return (
    <div className="mb-4">
      <div className="flex items-start justify-between gap-2">
        <div>
          <SubTitle text={title} />
          <div className="my-2">{subheading}</div>
        </div>

        <div className="flex items-center gap-4">
          {hasUnsavedChanges && (
            <Badge className="rounded-full border border-amber-300 bg-amber-100 px-3 py-1 text-xs font-medium text-amber-800">
              Unsaved changes
            </Badge>
          )}
          {action && action}
        </div>
      </div>
    </div>
  );
}
